import { useTranslations } from '@vocab/react';
import { Stack, Heading, Box } from 'braid-design-system';
import React from 'react';

import { LANGUAGES } from 'src/components/Router';

import { Languages as ProfileLanguages } from '../../Languages/Languages';
import { useShareableProfile } from '../data';

import translations from './.vocab';

export const Languages = () => {
  const { shareableProfile, shareableProfileCardEmpty } = useShareableProfile();
  const { t } = useTranslations(translations);
  const languages = shareableProfile?.languageProficiencies || [];

  return shareableProfileCardEmpty[LANGUAGES] ? null : (
    <Box id={LANGUAGES} paddingTop="xxlarge" data-automation={LANGUAGES}>
      <Stack space="large">
        <Heading level="3" align="left">
          {t('Languages')}
        </Heading>
        <ProfileLanguages
          languages={languages.map((language) => ({
            ...language,
          }))}
        />
      </Stack>
    </Box>
  );
};
